const ErrorBoundary = ({
  error,
}: {
  error: { name: string; message: string }
}) => {
  if (!error) {
    return null
  }

  const isChunkError =
    error.name === 'ChunkLoadError' ||
    /Loading chunk \d+ failed/.test(error.message)

  const message = isChunkError ? 'Site updated!' : 'Something went wrong.'
  const description = isChunkError
    ? 'Refresh to enjoy the update.'
    : "We're working on getting this fixed as soon as we can. You can refresh the page or try again later."

  return (
    <div className="h-full relative bg-white">
      <div className="w-full text-center absolute top-1/2 right-1/2 transform -translate-y-3/4 translate-x-1/2 p-4 sm:p-6">
        <h1 className="text-pop-gray mt-8">{message}</h1>
        <p className="text-pop-gray-200 mt-4 max-w-lg m-auto">{description}</p>
        <button
          className="btn btn-primary mt-4"
          onClick={() => window.location.reload()}
        >
          Refresh
        </button>
      </div>
    </div>
  )
}

export default ErrorBoundary
